export function Hero() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center md:space-x-12 space-y-8 md:space-y-0">
      <div className="flex-1">
        <span className="text-sm uppercase tracking-wider bg-gray-200 px-2 py-1 rounded-full text-gray-700">
          Ethos Tech Hub Limited
        </span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-4">
          Ethos | AI PO Processing
        </h1>
        <p className="mt-4 text-gray-600 text-lg">
          Revolutionize your order processing with our intelligent AI solution that automatically 
          extracts data from customer purchase orders and generates sales orders directly into your ERP system. 
          Eliminate manual data entry, reduce errors, and accelerate your order-to-cash cycle with 
          precision and efficiency powered by artificial intelligence.
        </p>
        
      </div>
      <div className="flex-1">
        <img
          src="/images/aiprocessing/aiprocessing.png"
          alt="AI PO Processing Dashboard"
          className="w-64 mx-auto shadow-lg rounded-lg"
        />
      </div>
    </section>
  );
}